/* globals femcare  */

femcare.shared.tooltips = {
    init: function () {
        $(document).tooltip({
            classes: {
                'ui-tooltip': 'tooltip',
                'ui-tooltip-content': 'tooltip__content'
            }
        });
    }
};